import { actionTypes } from 'app/types/action_types';

const initialState = {
  faq: [],
};

const mapInitialPayloadAction = (state, payload) => ({
  ...state,
  faq: payload.faq,
});

// eslint-disable-next-line default-param-last
const aiLandingPageReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.INITIALIZE:
      return mapInitialPayloadAction(state, action.payload);
    default:
      return state;
  }
};

export default aiLandingPageReducer;
